import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';

export function resolveNotificationCenterRoute(activeScopeCode: string | null): string {
  if (activeScopeCode === 'platform') {
    return APPLICATION_ROUTES.adminNotifications;
  }
  if (activeScopeCode === 'client') {
    return APPLICATION_ROUTES.clientPortalNotifications;
  }
  return APPLICATION_ROUTES.workspaceNotifications;
}

export function resolveInAppNavigationPath(actionUrl: string | null): string | null {
  if (actionUrl === null || actionUrl.length === 0) {
    return null;
  }
  try {
    const parsedUrl = new URL(actionUrl, window.location.origin);
    return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
  } catch {
    return null;
  }
}
